import './App.css';

import { useState } from "react";
import "./App.css";

const questions = [
  {
    question: "Quel est le mot qui décrit le mieux votre couple ?",
    options: ["Spontané", "Romantique", "Aventurier", "Discret"],
  },
  {
    question: "Pour vous, une photo réussie c’est…",
    options: [
      "Un instant capturé sur le vif",
      "Une belle lumière et une pose soignée",
      "Un décor de rêve et une ambiance forte",
      "Une émotion subtile mais vraie",
    ],
  },
  {
    question: "Votre moment idéal pour une séance photo ?",
    options: [
      "Une balade improvisée dans la nature",
      "Juste avant le coucher du soleil",
      "Un week-end dans un lieu insolite",
      "Chez vous, dans votre cocon",
    ],
  },
  {
    question: "Quel type de souvenirs voulez-vous garder ?",
    options: [
      "Des éclats de rire, des regards complices",
      "Des photos élégantes et intemporelles",
      "Une expérience originale à raconter",
      "Des petits gestes tendres, naturels",
    ],
  },
  {
    question: "Quand vous regardez des photos de couple, vous préférez…",
    options: [
      "Les moments spontanés, pas posés",
      "Les photos qui ressemblent à une œuvre d’art",
      "Les mises en scène créatives",
      "Les photos simples mais pleines d’émotions",
    ],
  },
];

const results = [
  {
    title: "🌿 Séance lifestyle en extérieur",
    description:
      "Vous aimez l’authenticité, la nature et les moments vrais. Une balade à deux, capturée sans pression, vous permettra d’avoir des souvenirs fidèles à votre complicité.",
  },
  {
    title: "💫 Séance fine art ou éditoriale",
    description:
      "Vous appréciez l’esthétique et le soin du détail. Une prestation plus posée, dans un lieu choisi avec une lumière travaillée, révélera toute la beauté de votre couple.",
  },
  {
    title: "🌍 Évasion photo",
    description:
      "Un road trip, une escapade en van, un paysage unique ? Vous rêvez de photos hors du commun, avec du mouvement et de l’originalité.",
  },
  {
    title: "🕊️ Séance intimiste et douce",
    description:
      "Chez vous ou dans un lieu calme, avec un regard sensible. Votre couple est fort dans les détails, les silences et la tendresse.",
  },
];

export default function QuizPhotoStyle() {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (index) => {
    setAnswers([...answers, index]);
    const next = current + 1;
    if (next < questions.length) {
      setCurrent(next);
    } else {
      setShowResult(true);
    }
  };

  const getResult = () => {
    const count = [0, 0, 0, 0];
    answers.forEach((ans) => count[ans]++);
    const maxIndex = count.indexOf(Math.max(...count));
    return results[maxIndex];
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "1rem" }}>
      {!showResult ? (
        <div style={{ border: "1px solid #ccc", borderRadius: "8px", padding: "1rem" }}>
          <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "1rem" }}>
            {questions[current].question}
          </h2>
          <div style={{ display: "grid", gap: "0.5rem" }}>
            {questions[current].options.map((opt, idx) => (
              <button
                key={idx}
                onClick={() => handleAnswer(idx)}
                style={{
                  padding: "0.75rem 1rem",
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div style={{ border: "1px solid #ccc", borderRadius: "8px", padding: "1rem", textAlign: "center" }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "0.5rem" }}>
            {getResult().title}
          </h2>
          <p style={{ fontSize: "1rem", color: "#666" }}>{getResult().description}</p>
        </div>
      )}
    </div>
  );
}
